import type { PayloadAction } from "@reduxjs/toolkit";
import type { currentSurveySliceState } from "@survey-types/survey.core.types";

export const bingMapReducers = {
  setBingMap: (
    state: currentSurveySliceState,
    action: PayloadAction<any | null>,
  ) => {
    state.currentBingMap = action.payload;
  },
};
